var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfiguration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F1F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M7 7H25V25H7V7Z",
    fill: "#2E5BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0173 9.03772L21.934 13.3576C22.0541 13.4897 22.1208 13.6616 22.1212 13.84V21.3999L22.1212 21.4001C22.1092 22.4061 21.284 23.2119 20.2781 23.1999H12.4446L12.4443 23.1999C11.4384 23.2117 10.6133 22.4058 10.6014 21.3999V10.6001L10.6014 10.5998C10.6134 9.59388 11.4387 8.78812 12.4446 8.80012H17.4845C17.6877 8.8006 17.8812 8.88689 18.0173 9.03772ZM19.7742 13.12L17.8014 10.96V12.508L17.8007 12.5179C17.7818 12.8315 18.0207 13.101 18.3342 13.12H19.7742ZM20.2769 21.76H12.4434C12.233 21.7722 12.0525 21.6116 12.0403 21.4012L12.0402 21.4V10.6002C12.0518 10.3897 12.2318 10.2285 12.4422 10.2401L12.4434 10.2402H16.3601V12.5081C16.3359 13.6122 17.2074 14.5287 18.3113 14.5601H20.6801V21.4C20.6685 21.6104 20.4885 21.7716 20.2781 21.76L20.2769 21.76ZM14.2004 17.4399H16.3604C16.758 17.4399 17.0804 17.1175 17.0804 16.7199C17.0804 16.3222 16.758 15.9999 16.3604 15.9999H14.2004C13.8028 15.9999 13.4804 16.3222 13.4804 16.7199C13.4804 17.1175 13.8028 17.4399 14.2004 17.4399ZM14.2004 18.8798C13.8028 18.8798 13.4804 19.2022 13.4804 19.5998C13.4804 19.9975 13.8028 20.3198 14.2004 20.3198H18.5204C18.918 20.3198 19.2403 19.9975 19.2403 19.5998C19.2403 19.2022 18.918 18.8798 18.5204 18.8798H14.2004Z",
    fill: "#2E5BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiguration);
export default __webpack_public_path__ + "static/media/configuration.af502a87.svg";
export { ForwardRef as ReactComponent };